export interface WorkspaceLanguages {
	defaultLanguage: string
	enabledLanguages: string[]
}

export function resolveWorkspaceLanguages(workspace: {
	defaultLanguage?: string | null
	enabledLanguages?: readonly string[] | null
}): WorkspaceLanguages {
	const enabledLanguages = workspace.enabledLanguages?.length
		? [...workspace.enabledLanguages]
		: ["en"]
	return {
		defaultLanguage: workspace.defaultLanguage || "en",
		enabledLanguages,
	}
}

export function orderDefaultFirst({
	defaultLanguage,
	enabledLanguages,
}: WorkspaceLanguages): string[] {
	const rest = enabledLanguages.filter((code) => code !== defaultLanguage)
	return enabledLanguages.includes(defaultLanguage)
		? [defaultLanguage, ...rest]
		: rest
}

export function addLanguage(
	state: WorkspaceLanguages,
	code: string,
): WorkspaceLanguages {
	if (state.enabledLanguages.includes(code)) return state
	return { ...state, enabledLanguages: [...state.enabledLanguages, code] }
}

export function makeDefaultLanguage(
	state: WorkspaceLanguages,
	code: string,
): WorkspaceLanguages {
	return { ...addLanguage(state, code), defaultLanguage: code }
}

export function canRemoveLanguage(state: WorkspaceLanguages): boolean {
	return state.enabledLanguages.length > 1
}

// Removing the default hands it to the next enabled language, so the portal
// always has a fallback. The last language can't be removed.
export function removeLanguage(
	state: WorkspaceLanguages,
	code: string,
): WorkspaceLanguages | null {
	if (!canRemoveLanguage(state) || !state.enabledLanguages.includes(code)) {
		return null
	}
	const enabledLanguages = state.enabledLanguages.filter((c) => c !== code)
	const defaultLanguage =
		state.defaultLanguage === code
			? enabledLanguages[0]!
			: state.defaultLanguage
	return { defaultLanguage, enabledLanguages }
}
